module.exports = __webpack_public_path__ + "static/img/guilin.e599dfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/city/guilin.jpg
// module id = A4qs
// module chunks = 1